import { Grid } from '@material-ui/core';

import styled from 'styled-components';

import { fontFamily } from '../../libs';

export const Container = styled(Grid)`
  width: 250px !important;
  padding: 7px;

  * {
    font-family: ${fontFamily} !important;
  }
`;

export default {};
